<template>
  <div>
    <lk-form-item label='医保类型:'>
      <lk-radio-group v-model="type" @on-change='handleType'>
        <lk-radio :label='1'>普药医保</lk-radio>
        <lk-radio :label='2'>慢病医保</lk-radio>
      </lk-radio-group>
    </lk-form-item>
    <lk-form-item label='医保卡验证:'>

      <lk-button :disabled='insuranceCheckArr[0]' type='primary' size='small'
        @click='checkInsurance'>验证</lk-button>
      <div class='infoList'>
        <div class='infoItem'>
          <label>
            <span>个人编号：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>单位名称：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>身份证号：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>姓名：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>性别：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>出生日期：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>医疗人员类别：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>医疗照顾人员标志：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>公务员类别：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>参加公务员统筹：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>人员状态：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>账户余额：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>年度住院次数：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>年度统筹支付：</span>
          </label>
          <span>{{100}}</span>
        </div>

        <div class='infoItem'>
          <label>
            <span>年度慢性病余额：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>慢性病年限额：</span>
          </label>
          <span>{{100}}</span>
        </div>
      </div>
    </lk-form-item>
    <lk-form-item label='医保预结算:'>
      <lk-button :disabled='insuranceCheckArr[1]' class="mr8" type='primary' size='small'
        @click='insurancePreSettlement'>申请预结算</lk-button>
      <lk-button :disabled='insuranceCheckArr[2]' type='primary' size='small'
        @click='insuranceSettlement'>医保结算</lk-button>
      <div class='infoList'>
        <div class='infoItem'>
          <label>
            <span>医保支付：</span>
          </label>
          <span>{{100}}</span>
        </div>
        <div class='infoItem'>
          <label>
            <span>个人支付：</span>
          </label>
          <span>{{100}}</span>
        </div>
      </div>
    </lk-form-item>
  </div>
</template>
<script>
export default {
  name: 'ShaanXiProvincePayComp',
  data() {
    return {
      insuranceCheckArr: [
        true, true, true,
      ],
      type: null,
    };
  },
  methods: {
    handleType(val) {
      if (val) {
        this.$set(this.insuranceCheckArr, 0, false);
      }
    },
    checkInsurance() {
      console.log('验证医保卡');
      // this.insuranceCheckArr[1] = false;
      this.$set(this.insuranceCheckArr, 1, false);
    },
    insurancePreSettlement() {
      console.log('医保预结算');
      this.$set(this.insuranceCheckArr, 2, false);
      // this.insuranceCheckArr[2] = false;
    },
    insuranceSettlement() {
      console.log('医保结算');
    },
  },
};

</script>
<style lang="less" scoped>
  .infoList {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    line-height: 24px;

    .infoItem {
      display: flex;
      width: 230px;
      margin-bottom: 8px;

      // img {
      //   width: 16px;
      //   height: 16px;
      //   margin-right: 8px;
      // }

      label {
        width: 100px;
        text-align: left;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        justify-content: flex-end;

        span {
          flex-shrink: 0
        }
      }

    }
  }

</style>
